import React from "react";
import Table from "../base-table";
import type { TableRef } from "../base-table";
import { getCoreRowModel } from "@tanstack/react-table";
import { CustomsStatusDocument } from "../../graphql/graphql";

import { getFilingPackStatusTableColumns, flattenFilingPacksToStatusRows } from "./DeclarationStatusTableColumns";

interface DeclarationStatusTableProps {
  data: CustomsStatusDocument[];
  tableRef: React.Ref<TableRef>;
}

export const DeclarationStatusTable: React.FC<DeclarationStatusTableProps> = ({ data, tableRef }) => {
  const columns = React.useMemo(() => getFilingPackStatusTableColumns(), []);
  const rowModel = getCoreRowModel();

  const filingPackStatusRows = flattenFilingPacksToStatusRows(data);

  return (
    <Table
      ref={tableRef}
      data={filingPackStatusRows}
      columns={columns}
      getCoreRowModel={rowModel}
    />
  );
};


